export default __webpack_public_path__ + "static/media/stand_1.cb401ce5.jpg";